export default __webpack_public_path__ + "5a36392239b15ac274385d2cc3584981.svg";